const getFilterData = state  => state.filterData;
const isFilterLoading = state  => state.isFilterLoading;

const getCoverageList = state  => state.coverageList;
const isCoverageListLoading = state => state.isCoverageListLoading;

const getTotalSummary = state  => state.totalSummary;
const isTotalSummaryLoading = state => state.isTotalSummaryLoading;

const getTransition = state  => state.transition;
const isTransitionLoading = state => state.isTransitionLoading;

export default {
  getFilterData,
  isFilterLoading,
  getCoverageList,
  isCoverageListLoading,
  getTotalSummary,
  isTotalSummaryLoading,
  getTransition,
  isTransitionLoading
};



// WEBPACK FOOTER //
// ./src/store/modules/savings-plans/coverage/getters.js